<template>
    <v-btn @click="onClick"
           :disabled="isDisabled"
           :content="showLutPreviews ? 'Collapse Previews column' : 'Expand Previews column'"
           v-tippy="{placement: 'right', boundary: 'window'}"
    >
        <v-icon v-if="showLutPreviews && !isDisabled" class="material-symbols-outlined">left_panel_close</v-icon>
        <v-icon v-else-if="isDisabled" class="material-symbols-outlined">left_panel_open</v-icon>
        <v-icon v-else class="material-symbols-outlined">left_panel_open</v-icon>
    </v-btn>
</template>

<script>
import { mapState } from "vuex";
import CanMixin from "@/mixins/CanMixin";

export default {
    mixins: [CanMixin],

    computed: {
        ...mapState("App", ["IDT", "blockLoading"]),
        ...mapState("UI", ['showLutPreviews', 'previewBasedBlock']),
        ...mapState("Projects", ['image']),
        isDisabled() {
            return !this.canUseColorGradingTools || !this.previewBasedBlock || this.blockLoading || !this.image || this.IDT.initial
        }
    },
    methods: {
        onClick() {
            if (this.showLutPreviews) {
                this.$store.dispatch('UI/setShowLutPreviews', false);
                window.lutify.getActiveBlock().collapsedPreviews = true;
                this.$nextTick(() => {
                    window.lutPreviewer?.renderer?.clear();
                })
            } else {
                this.$store.dispatch('UI/setShowLutPreviews', true);
                window.lutify.getActiveBlock().collapsedPreviews = false;
                this.$nextTick(() => {
                    if (window.lutify.getActiveBlock()) window.UI.getActiveBlock().click();
                })
            }
        },
    },
};
</script>